

































































import { generateQRCode, generateScreenShots } from "../../../api/share"
import { getUserAgent } from "../../../utils/ua"
import { Component, Vue, Prop } from "vue-property-decorator"

interface actionFunc {
  (): void
}

@Component
export default class SharePrompt extends Vue {
  @Prop(String) private shareUrl?: string
  @Prop(String) private mainImg?: string
  @Prop(String) private logoImg?: string
  @Prop(String) private name?: string
  @Prop(String) private price?: string
  @Prop(String) private friendsGreet?: string
  @Prop(String) private friendsMsg?: string
  @Prop(String) private demander?: string
  @Prop(String) private demanderNick?: string
  @Prop(String) private demanderAvatar?: string
  @Prop(String) private gameCoinLogo?: string
  @Prop(String) private shareTips?: string
  @Prop({
    type: Boolean,
    default: () => {
      return false
    }
  })
  private hideShareArrow?: boolean
  @Prop({
    type: Boolean,
    default: () => {
      return false
    }
  })
  private gameCoin?: boolean
  @Prop({ type: Function, default: () => {} }) private onComplete!: actionFunc
  @Prop({ type: Function, default: () => {} }) private onSucces!: actionFunc
  @Prop({ type: Function, default: () => {} }) private onError!: actionFunc

  shareImg: string = ""
  generateComplete: boolean = false
  display = true
  userAgent = getUserAgent()

  show() {
    this.display = true
  }

  closeShareBox() {
    this.display = false
  }

  renderShare() {
    if (!this.shareUrl) return

    let promiseArr = [
      this.getUrlQRCode(this.shareUrl),
      this.getBase64(this.mainImg),
      this.getBase64(this.demanderAvatar),
      this.getBase64(this.logoImg)
    ]
    if (this.gameCoin) {
      promiseArr.push(this.getBase64(this.gameCoinLogo))
    }

    Promise.all(promiseArr)
      .then(([urlBaseURL, imgBaseURL, avatarBaseURL, logoImgURL, gameCoinLogoURL]: any) => {
        // 地址二维码
        ;(<HTMLImageElement>document.getElementById("sharecode")).src = urlBaseURL

        // 图片base64
        this.setDomBase64("shareAvatarImg", avatarBaseURL)

        this.setDomBase64("logoImg", logoImgURL)

        if (this.gameCoin && typeof imgBaseURL === "string" && imgBaseURL.indexOf("base64") > -1) {
          ;(<HTMLImageElement>document.getElementById("shareMainBgImg")).style.backgroundImage = `url(${imgBaseURL})`
        } else {
          this.setDomBase64("shareMainImg", imgBaseURL)
        }

        this.setDomBase64("gameCoinLogo", gameCoinLogoURL)

        if (this.gameCoin && gameCoinLogoURL) {
          this.setDomBase64("gameCoinLogo", gameCoinLogoURL)
        }

        generateScreenShots("friendPayShareContainer")
          .then(base64Img => {
            this.generateComplete = true
            this.shareImg = base64Img
            this.onSucces()
          })
          .catch(() => {
            this.closeShareBox()
            this.onError()
          })
          .finally(() => {
            this.onComplete()
          })
      })
      .catch(() => {
        this.closeShareBox()
        this.onComplete()
        this.onError()
      })
  }

  getUrlQRCode(shareUrl) {
    return new Promise((resolve, reject) => {
      generateQRCode({
        url: shareUrl,
        success: url => {
          resolve(url)
        },
        fail: err => {
          reject(err)
        }
      })
    })
  }

  getBase64(url, outputFormat = "image/png", catchError = false) {
    // 如果地址是http地址，则转为base64，如果已经是base64则无需转换
    return new Promise((resolve, reject) => {
      if (url.indexOf("base64") > -1) {
        resolve(url)
      } else {
        try {
          let canvas: any = document.createElement("canvas"),
            ctx = canvas.getContext("2d"),
            img = new Image()

          img.crossOrigin = "Anonymous"
          img.onload = () => {
            canvas.height = img.height
            canvas.width = img.width
            ctx?.drawImage(img, 0, 0)
            let dataURL = canvas.toDataURL(outputFormat)
            canvas = null
            resolve(dataURL)
          }
          img.onerror = error => {
            catchError ? reject(error) : resolve(error)
          }

          img.src = `${url}?t=${+new Date()}`
        } catch (error) {
          catchError ? reject(error) : resolve(error)
        }
      }
    })
  }

  setDomBase64(domId, base64) {
    // 图片base64
    if (typeof base64 === "string" && base64.indexOf("base64") > -1) {
      ;(<HTMLImageElement>document.getElementById(domId)).src = base64
    }
  }

  mounted() {
    this.$nextTick(() => {
      this.renderShare()
    })
  }
}
